import React from 'react';
import { Button } from 'antd';
// eslint-disable-next-line no-restricted-imports
import { useDeleteRegionalCalendar } from 'features/regionalCalendar/delete';
import { isHasAccess } from 'features/validateAccess';
import { CalendarDTO } from 'entities/calendar';
import { ReactComponent as DeleteIcon } from 'shared/assets/icons/calendarDelete.svg';
import { DELETE_CALENDAR } from '../../../permissions';

import styles from './UpdateRegionalCalendarFooter.module.scss';

const UpdateRegionalCalendarFooter = ({
  calendar,
  children,
}: {
  calendar: CalendarDTO;
  children: React.ReactNode;
}): React.ReactElement => {
  const openDeleteModal = useDeleteRegionalCalendar(calendar.id, calendar.name);

  const canDeleteCalendar = isHasAccess(DELETE_CALENDAR);

  return (
    <div className={styles.wrapper}>
      {canDeleteCalendar ? <Button icon={<DeleteIcon />} danger onClick={openDeleteModal} /> : <div />}
      <div className={styles.actionsBtnBlock}>{children}</div>
    </div>
  );
};

export { UpdateRegionalCalendarFooter };
